export var mutations = {
    setUser: function (s, payload) { return s.user = payload; },
    setLoading: function (s, payload) { return s.loading = payload; },
    setUploadingAvatar: function (s, payload) { return s.uploadingAvatar = payload; },
};
